import AuthCard from '../components/AuthCard/AuthCard';

function Login() {
  return <AuthCard mode="login" />;
}

export default Login;
